<template>
    <div class="cardContainer" :class="[
        activityStatus == 1 ? 'status-border-success' : 
        activityStatus == 2 || activityStatus == 3 ? 'status-border-error' : 
        'status-border-pending'
     ]">
        <van-row v-if="!isShowDetails">
            <van-col span="3" class="dayColumn">
                <div class="check-badge"
                    :class="activityStatus == 1 ? 'check-badge' : activityStatus == 2 ? 'check-badge-2' : activityStatus == 3 ? 'check-badge-2' : activityStatus == 0 ? 'check-badge-1' : ''">
                    <van-icon v-if="activityStatus == 0" name="underway-o " color="#4975c5" />
                    <van-icon v-if="activityStatus == 1" name="success" color="#ffffff6b" />
                    <van-icon v-if="activityStatus == 2 || activityStatus == 3" name="cross" color="#ffadad" />
                </div>
            </van-col>
            <van-col span="4" class="dayColumn">
                <div class="calendar-wrapper">
                    <img v-if="activityStatus == 0" src="@/assets/rechargeGift/blue_calender.png" width="100%" height="100%" 
                        style="border-radius: 10px;">
                    <img v-if="activityStatus == 1" src="@/assets/rechargeGift/green_calender.png" width="100%" height="100%" 
                        style="border-radius: 10px;">
                    <img v-if="activityStatus == 2 || activityStatus == 3" src="@/assets/rechargeGift/red_calender.png" height="100%" 
                        width="100%" style="border-radius: 10px;">
                    <div class="calendar">
                        <div class="cal-header">{{ year }}</div>
                        <div class="cal-body">
                            <span class="month">{{ month }}</span>
                            <span class="day">{{ day }}</span>
                        </div>
                    </div>
                </div>
            </van-col>
            <van-col span="2" class="topRow">
                <div class="line"></div>
            </van-col>
            <van-col span="8" class="DataRow" style="margin: 10px 0;">
                <div class="dayTitle" style="font-size: 12px;">{{ $t('activity.givenAmount') }}</div>
                <div class="givenAmount"> {{ formatCurrency(givenAmount) }} <img src="@/assets/rechargeGift/coin.png"
                        alt="" width="15%" style="padding-left: 5px;"></div>
            </van-col>
            <van-col span="7" class="dayColumn" style="padding-right: 4%;">
                <div class="status-badge"
                    :class="activityStatus == 1 ? 'status-badge' : activityStatus == 2 ? 'status-badge-2' : activityStatus == 3 ? 'status-badge-2' : activityStatus == 0 ? 'status-badge-1' : ''">
                    <div class="check-badge"
                        :class="activityStatus == 1 ? 'check-badge' : activityStatus == 2 ? 'check-badge-2' : activityStatus == 3 ? 'check-badge-2' : activityStatus == 0 ? 'check-badge-1' : ''">
                        <van-icon v-if="activityStatus == 0" name="underway-o " color="#4975c5" />
                        <van-icon v-if="activityStatus == 1" name="success" color="#ffffff6b" />
                        <van-icon v-if="activityStatus == 2 || activityStatus == 3" name="cross" color="#ffadad" />
                    </div>
                    <p v-if="props.activityStatus == 0" style="color: #0484ff;">{{
                        $t('activityStatus.pending') }}</p>
                    <p v-else-if="props.activityStatus == 1" style="color: #36d836;">{{
                        $t('activityStatus.completed')
                        }}</p>
                    <p v-else-if="props.activityStatus == 2" style="color: #ff0000;">{{
                        $t('activityStatus.noRewards')
                        }}</p>
                    <p v-else-if="props.activityStatus == 3" style="color: #ff0000;">{{ $t('activity.overdue')
                        }}</p>
                </div>

            </van-col>
        </van-row>
    </div>
</template>
<script lang="ts" setup>
import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { computed, PropType, ref, } from 'vue';

const props = defineProps({
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
})
const dateObj = computed(() => {
    if (!props.createTime) return new Date();
    const dateString = props.createTime;
    return new Date(dateString);
});

const year = computed(() => dateObj.value.getFullYear());
const day = computed(() => dateObj.value.getDate());
const month = computed(() => dateObj.value.toLocaleString('en-US', { month: 'long' }));
</script>
<style scoped>
.cardContainer {
    background: #011f1a;
    border: 0.5px solid #00b8bf1f;
    border-radius: 10px;
    padding: 5px;
    color: #fff;
    font-size: 12px;
    margin: 10px 0 0;
    font-family: 'Roboto';
}
.status-border-success {
    border-left: 2px solid #36d836a5 !important;
    box-shadow: -10px 0px 10px -5px rgba(54, 216, 54, 0.4);
}

.status-border-pending {
    border-left: 2px solid #0486ffb0 !important;
    box-shadow: -10px 0px 10px -5px rgba(4, 132, 255, 0.4);
}

.status-border-error {
    border-left: 2px solid #ff0000 !important;
    box-shadow: -10px 0px 10px -5px rgba(255, 0, 0, 0.4);
}
.claimCard {
    background: linear-gradient(180deg, #142111 0%, #0a0f08 100%);
    border: 1px solid #2a3d24;
}

.pendingCard {
    background: linear-gradient(180deg, #121121 0%, #08080f 100%);
    border: 1px solid #24293d;
}

.norewardCard {
    background: linear-gradient(180deg, #211111 0%, #0f0808 100%);
    border: 1px solid #3d2424;
}

.refund-card {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    display: flex;
    padding: 15px 15px 10px;
    color: #fff;
    gap: 20px;
    border-left: 2px solid;
    border-image: linear-gradient(180deg, transparent 5%, #3e8b2d 25%, transparent 50%) 1;
}

.refund-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #26790a 0%, #167c2b 25%, #348918 45%, transparent 50%);
    z-index: 1;
}

.refund-card-1 {
    border-left: 2px solid;
    border-image: linear-gradient(180deg, transparent 5%, #2d3a8b 25%, transparent 50%) 1;
}

.refund-card-1::before {
    background: linear-gradient(135deg, #042c90 0%, #162f7c 25%, #183289 45%, transparent 50%);
}

.refund-card-2 {
    border-left: 2px solid;
    border-image: linear-gradient(180deg, transparent 5%, #8b2d2d 25%, transparent 50%) 1;
}

.refund-card-2::before {
    background: linear-gradient(135deg, #790a0a 0%, #7c1616 25%, #891818 45%, transparent 50%);
}

.calendar-wrapper {
    position: relative;
    z-index: 2;
    margin-left: 5%;
}

.check-badge {
    background: radial-gradient(circle, rgb(69 180 49 / 29%) 0%, rgb(1 39 1 / 27%) 100%);
    padding: 5%;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    z-index: 2;
    border: 3px solid #1e8e059c;
}

.check-badge-1 {
    border: 3px solid #033a90;
    background: radial-gradient(circle, rgb(49 136 180 / 45%) 0%, rgb(3 7 66 / 60%) 100%);
}

.check-badge-2 {
    border: 3px solid #ba0000;
    background: radial-gradient(circle, rgb(180, 49, 49) 0%, rgb(66, 3, 3) 100%);
}

.calendar {
    position: absolute;
    top: 5px;
    left: 0;
    right: 0;
    border-radius: 6px;
    overflow: hidden;
    text-align: center;
}

.cal-header {
    color: white;
    font-size: 12px;
    padding: 2px 0;
    font-weight: bold;
}

.cal-body {
    color: #333;
    padding: 5% 0;
}

.cal-body .month {
    display: block;
    font-size: 11px;
    padding-top: 5%;
    font-weight: bold;
    color: #666;
    text-transform: uppercase;
}

.cal-body .day {
    padding-top: 5%;
    display: block;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
}

.cal-body .weekday {
    font-size: 10px;
    color: #666;
}

.stats-section {
    width: 100%;
}

.status-badge {
    display: flex;
    align-items: center;
    background: radial-gradient(circle, rgb(1 39 1 / 27%) 0%, rgba(57, 154, 39, 0.29) 100%);
    color: #4caf50;
    border: 1px solid #2a4d21;
    padding: 0px;
    border-radius: 30px;
    font-size: 1.15vh;
    width: 100%;
    overflow: hidden;
}

.status-badge-1 {
    background: radial-gradient(circle, rgb(3 7 66 / 60%) 0%, rgba(19, 37, 105, 0.45) 100%);
    color: #4e4caf;
    border: 1px solid #21244d;
}

.status-badge-2 {
    background: radial-gradient(circle, rgb(66 3 3 / 60%) 0%, rgb(124, 27, 27, 0.45) 100%);
    color: #af4c4c;
    border: 1px solid #4d2121;
}

.status-badge p {
    margin: 0px;
    text-transform: uppercase;
    padding: 0 5%;
}

/* .stats-grid {
    display: flex;
    align-items: center;
    gap: 15px;
} */
.stat-item {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.stat-item p {
    font-size: 12px;
    color: #d8d8d8bd;
    margin: 0 0 5px 0;
    text-align: center;
}

.stat-item .value {
    font-size: 16px;
    font-weight: bold;
    color: #e3b453;
    text-align: center;
}

/* 3. Right Grid Section */
.details-section {
    flex-grow: 1;
    border-left: 1px solid #333;
    padding-left: 20px;
}

.section-title {
    font-size: 10px;
    color: #666;
    text-align: right;
    margin-bottom: 10px;
}

.details-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1px;
    /* Creates the internal lines */
    background: #222;
    /* Line color */
    border: 1px solid #222;
}

.grid-item {
    background: #0d140b;
    /* Item background */
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.grid-item .date {
    font-size: 9px;
    color: #888;
    text-transform: uppercase;
}

.grid-item .amount {
    font-size: 12px;
    font-weight: bold;
    color: #4caf50;
}

.grid-item.highlight .amount {
    color: #66bb6a;
}

.grid-item.high-value .amount {
    color: #a5d6a7;
    font-size: 14px;
}

.grid-item.more {
    justify-content: center;
    color: #666;
    cursor: pointer;
}


.topRow {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.DataRow {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.right-texts {
    text-align: center;
    display: flex;
}

.day-num {
    position: absolute;
    font-size: 20px;
    white-space: nowrap;
    color: #FFF5D7;
    text-shadow: -1px -1px 0 #300000, 1px -1px 0 #300000, -1px 1px 0 #300000, 1px 1px 0 #300000;
    z-index: 800;
    font-weight: 700;
    left: 55%;
    top: 25%;
}

.dateText {
    position: absolute;
    top: 50%;
    padding: 5px 0;
    font-size: 6px;
    color: #000;
    font-weight: 600;
}

.dayImage img {
    width: 80%;
    padding: 0 0 5px;
    position: relative;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.dayImage2 img {
    width: 75px;
    height: 50px;
    position: relative;
}

.dayImage2 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.centerAlignment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.line {
    width: 1px;
    background: #d0d5ff3d;
    height: 60%;
    margin: 5px;
}

.dayCard {
    color: #ffffffac;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 0;
    min-width: 13%;
    flex-shrink: 0;
    border: 1px solid #6161611b;
}

.dayCardWrapper {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex: 1;
}

.dayCardWrapper::-webkit-scrollbar {
    display: none;
}

.scrollRow {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 5px;
}

.arrowLeft img {
    width: 10px;
}

.arrowRight {
    position: absolute;
    right: 0px;
}

.arrowLeft {
    position: absolute;
    left: 0px;
}

.arrowRight img {
    width: 10px;
    transform: rotate(180deg);
}

.dayTitle {
    padding-bottom: 5px;
    color: #ffffff6f;
}

.givenAmount {
    display: flex;
    align-items: center;
    font-size: 16px
}

.rightBorder {
    border-right: 1px solid #d0d5ff87;
}

.click_btn {
    color: #12151A;
    font-size: 11.5px;
    background-image: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 50%;
}

.valueText {
    padding: 2px 0 5px;
}

.bottomDayRow {
    display: flex;
    flex-direction: row;
}

@media (min-width:350px) {
    .dateText {
        font-size: 8px;
    }
}

@media (min-width:450px) {
    .dateText {
        font-size: 11px;
    }
}

@media (min-width: 600px) {
    .dateText {
        font-size: 10px;
    }
}

@media (min-width: 1920px) {
    .dateText {
        font-size: 14px;
    }
}
@media (max-width:450px) {
    .cal-body {
        padding: 0px;
    }
}
</style>